import type { DirectusNameTranslation } from './directusNameTranslation.model'
import { z } from 'zod'

export const directusNameTranslationDtoSchema = z.object({
  languages_code: z.string(),
  name: z.string(),
})

export type DirectusNameTranslationDto = z.infer<typeof directusNameTranslationDtoSchema>

export function transformDirectusNameTranslationDtoToDirectusNameTranslation(directusNameTranslationDtoSchema: DirectusNameTranslationDto): DirectusNameTranslation {
  return {
    languagesCode: directusNameTranslationDtoSchema.languages_code,
    name: directusNameTranslationDtoSchema.name,
  }
}
